/**
 * @description 文件 ID (enum)
 */
export enum DocsIdEnum {
  /** 保單條款 */
  PolicyTermsDoc = 'policyTermsDoc',
  /** 套印 */
  PrintEncert = 'printEncert',
  /** 使用說明 */
  UserManual = 'userManual',
  /** 註冊同意告知事項 */
  RegisterNoticeDoc = 'registerNoticeDoc',
  /** 投保同意告知事項 */
  InsureNoticeDoc = 'insureNoticeDoc'
}
